import {erIkkeNill, erNill} from "felles/stoettefunk/nillsjekk";
import {Debugger} from "debug";

const debug:Debugger = require('debug')('CriiptoBindFraTokenSesjonstjeneste');

export class CriiptoBindFraTokenSesjonstjeneste {

    static regNavn = 'CriiptoBindFraTokenSesjonstjeneste';
    private static nøkkel_epost = 'CriiptoBindFraTokenSesjonstjeneste.epost';
    private static nøkkel_token = 'CriiptoBindFraTokenSesjonstjeneste.resettoken';
    private static nøkkel_feilet_forsøk: string = "CriiptoBindFraTokenSesjonstjeneste.feiletInfo";

    static forInjisering() {
        return [
            CriiptoBindFraTokenSesjonstjeneste
        ]
    }

    constructor() {
    }

    lagre(epost: string, token: string) {
        debug('lagre', epost)
        if(erNill(epost) || erNill(token)) {
            debug('nope, kan ikke lager, epost eller token er null');
            // Trenger begge for å initiere.
            // Benytter anledningen til å sikre 100% opprydding
            this.nullstill();
            return;
        }
        sessionStorage.setItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_epost, epost);
        sessionStorage.setItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_token, token);
    }

    angiFeiletForsøkInformasjon(årsak: CriiptoBindBrukerFeiletForsøkÅrsak, epostForsøkt: string, epostBundet: string = '') {
        sessionStorage.setItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_feilet_forsøk, JSON.stringify({
            aarsak: årsak,
            epost_bundet: epostBundet,
            epost_forsoekt: epostForsøkt
        }));
    }

    feiletForsøkInformasjon(): CriiptoBindBrukerFeiletForsøk {
        return JSON.parse(sessionStorage.getItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_feilet_forsøk));
    }

    epost() {
        return sessionStorage.getItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_epost)
    }

    token() {
        return sessionStorage.getItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_token)
    }

    epostOgTokenErSatt() {
        return erIkkeNill(this.epost()) && erIkkeNill(this.token());
    }

    nullstill() {
        // nøkkel_feilet_epost_bundet & nøkkel_feilet_epost_forsøkt nullstilles ikke
        // da de kun benyttes til feilet-siden, og vil fjernes når nettleser-fanen lukkes.
        // Siden vi kaller nullstill() fra innloggingen, er dette viktig (hvis ikke vil feilet-siden mangle info)
        sessionStorage.removeItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_epost)
        sessionStorage.removeItem(CriiptoBindFraTokenSesjonstjeneste.nøkkel_token)
    }
}

export enum CriiptoBindBrukerFeiletForsøkÅrsak {
    annenBrukerKnyttetTilAngittEid,
    brukerAlleredeKnyttetTilEid
}

export interface CriiptoBindBrukerFeiletForsøk {
    aarsak: CriiptoBindBrukerFeiletForsøkÅrsak,
    epost_forsoekt: string,
    epost_bundet?: string
}
